function validateSelect(select) {
    const isFirstBlankSelected = select.selectedIndex === 0 && select.options[0].value.trim() === '';
    console.log(select, isFirstBlankSelected);
  
    select.classList.toggle('invalid', isFirstBlankSelected);
    select.classList.toggle('valid', !isFirstBlankSelected);
}

export default function SelectHandler() {
    const selectElements = document.querySelectorAll('select');

    if (selectElements) {
        selectElements.forEach((el) => {
            validateSelect(el);
            el.addEventListener('change', () => {
                validateSelect(el);
            });
        });
    }
}
  